import React from "react"
import { ReminderComponent } from "./ReminderComponent"
import { TranslationsProvider } from "@cirrus/core/i18n/provider"
import { AppTranslations } from "@cirrus/core/i18n/implementation/AppTranslations"

export const ReminderComponentProxy = (props: any) => (
  <TranslationsProvider translations={AppTranslations}>
    <ReminderComponent {...props} />
  </TranslationsProvider>
)